var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.003,
    height: 12.003,
    viewBox: "0 0 12.003 12.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71781",
    "data-name": "Group 71781",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71780",
    "data-name": "Group 71780",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31467",
    "data-name": "Path 31467",
    d: "M9.007,0h-6A3.01,3.01,0,0,0,0,3V9a3.01,3.01,0,0,0,3,3h6a3.01,3.01,0,0,0,3-3V3A3.01,3.01,0,0,0,9.007,0Zm2,9a2,2,0,0,1-2,2h-6a2,2,0,0,1-2-2V3a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V9Z",
    transform: "translate(-0.005 0)",
    fill: "#9fa2a5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71783",
    "data-name": "Group 71783",
    transform: "translate(8.507 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71782",
    "data-name": "Group 71782"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    fill: "#9fa2a5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71785",
    "data-name": "Group 71785",
    transform: "translate(3.006 3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71784",
    "data-name": "Group 71784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31468",
    "data-name": "Path 31468",
    d: "M105.406,102.4a3,3,0,1,0,3,3A3,3,0,0,0,105.406,102.4Zm0,5a2,2,0,1,1,2-2A2,2,0,0,1,105.406,107.4Z",
    transform: "translate(-102.405 -102.4)",
    fill: "#9fa2a5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.01cefa1ad5e5ccdb5f2bc3747f4c96a7.svg";
export { ForwardRef as ReactComponent };